import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getUseSentenceAllDaysAsync,
  userTwoDayPreviousWordsAsync,
  dayWiseSentencesAsync,
  addUserSentencesAsync,
  userWordOfTheDayBookmarksAsync,
  dailyUseSentenceBookmarksAsync,
} from "./dailyusesentence.async";

const initialState = {
  dailySentenceLoader: false,
  dailySentences: [],
  twodayPrevLoader: false,
  twodayPrev: [],
  dailyUseSentenceByIdLoader: false,
  dailyUseSentenceById: [],
  sentenceViewedLoader: false,
  sentenceViewed: [],
  allbookmarksLoader: false,
  bookmarks: [],
  dailyUseBookmarkLoader: false,
  dailyUseBookmark: [],
};

export const dailyusesentenceSlice = createSlice({
  name: "dailyusesentence",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(dailyUseSentenceBookmarksAsync.pending), (state) => {
      state.dailyUseBookmarkLoader = true;
    });
    builder.addMatcher(
      isAnyOf(dailyUseSentenceBookmarksAsync.fulfilled),
      (state, action) => {
        state.dailyUseBookmarkLoader = false;
        state.dailyUseBookmark = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(dailyUseSentenceBookmarksAsync.rejected),
      (state, action) => {
        state.dailyUseBookmarkLoader = false;
      }
    );

    builder.addMatcher(isAnyOf(getUseSentenceAllDaysAsync.pending), (state) => {
      state.dailySentenceLoader = true;
      state.dailySentences = [];
    });
    builder.addMatcher(
      isAnyOf(getUseSentenceAllDaysAsync.fulfilled),
      (state, action) => {
        state.dailySentenceLoader = false;
        state.dailySentences = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(getUseSentenceAllDaysAsync.rejected),
      (state, action) => {
        state.dailySentenceLoader = false;
        state.dailySentences = [];
      }
    );

    builder.addMatcher(
      isAnyOf(userTwoDayPreviousWordsAsync.pending),
      (state) => {
        state.twodayPrevLoader = true;
        state.wordofDay = [];
      }
    );
    builder.addMatcher(
      isAnyOf(userTwoDayPreviousWordsAsync.fulfilled),
      (state, action) => {
        state.twodayPrevLoader = false;
        state.twodayPrev = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(userTwoDayPreviousWordsAsync.rejected),
      (state, action) => {
        state.twodayPrevLoader = false;
        state.wordofDay = [];
      }
    );

    builder.addMatcher(isAnyOf(dayWiseSentencesAsync.pending), (state) => {
      state.dailyUseSentenceByIdLoader = true;
      state.dailyUseSentenceById = [];
    });
    builder.addMatcher(
      isAnyOf(dayWiseSentencesAsync.fulfilled),
      (state, action) => {
        state.dailyUseSentenceByIdLoader = false;
        state.dailyUseSentenceById = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(dayWiseSentencesAsync.rejected),
      (state, action) => {
        state.dailyUseSentenceByIdLoader = false;
        state.dailyUseSentenceById = [];
      }
    );

    builder.addMatcher(isAnyOf(addUserSentencesAsync.pending), (state) => {
      state.sentenceViewedLoader = true;
      state.sentenceViewed = [];
    });
    builder.addMatcher(
      isAnyOf(addUserSentencesAsync.fulfilled),
      (state, action) => {
        state.sentenceViewedLoader = false;
        state.sentenceViewed = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(addUserSentencesAsync.rejected),
      (state, action) => {
        state.sentenceViewedLoader = false;
        state.sentenceViewed = [];
      }
    );

    builder.addMatcher(
      isAnyOf(userWordOfTheDayBookmarksAsync.pending),
      (state) => {
        state.allbookmarksLoader = true;
        state.bookmarks = [];
      }
    );
    builder.addMatcher(
      isAnyOf(userWordOfTheDayBookmarksAsync.fulfilled),
      (state, action) => {
        state.allbookmarksLoader = false;
        state.bookmarks = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(userWordOfTheDayBookmarksAsync.rejected),
      (state, action) => {
        state.allbookmarksLoader = false;
        state.bookmarks = [];
      }
    );
  },
});

export default dailyusesentenceSlice.reducer;
